import React from "react";
import { makeNotFound as NotFoundContainer } from "../factories/containers";
export var NotFound = function () { return React.createElement(NotFoundContainer, null); };
